export const OPENING_WAREHOUSE = {
  PRODUCTS: "/opening-warehouse/products",
  NOTICES: "/opening-warehouse/notices",
};

export const FESTA_STAFF = {
  PRODUCTS: "/festa/products",
  NOTICES: "/festa/notices",
};

export const EXPERIENCE = {
  PRODUCTS: "/experience/products",
};

export const UTILS = {
  URL_VALIDATION: "/generic/code",
};

export const PARCEL = {
  PRODUCTS: "/parcel/products",
  SUBMIT: "/parcel/submit",
  ORDERS: "/parcel/orders",
  ORDER: "/parcel/order",
  ORDERS_STATUS: "/parcel/orders/status",
  DISCOUNT: "/parcel/discount",
};

export const ADMIN = {
  LOGIN: "/admin/login",
  EVENTS: "/admin/events",
  ACTIVE_EVENT: "/admin/events/active",
} as const;

export function adminEventActivatePath(eventId: number | string): string {
  return `${ADMIN.EVENTS}/${encodeURIComponent(String(eventId))}/activate`;
}

/** `GET`/`PUT` `/admin/events/{id}/products` — 상품 조회·전체 덮어쓰기 */
export function adminEventProductsPath(eventId: number | string): string {
  return `${ADMIN.EVENTS}/${encodeURIComponent(String(eventId))}/products`;
}

/** `GET`/`PUT` `/admin/parcel/{eventId}/products` — 배송 상품 조회·덮어쓰기 */
export function adminParcelProductsPath(eventId: number | string): string {
  return `/admin/parcel/${encodeURIComponent(String(eventId))}/products`;
}

/** `GET`/`PUT` `/admin/parcel/{eventId}/discount` — 배송 할인 정책 */
export function adminParcelDiscountPath(eventId: number | string): string {
  return `/admin/parcel/${encodeURIComponent(String(eventId))}/discount`;
}

export const API = {
  OPENING_WAREHOUSE,
  FESTA_STAFF,
  EXPERIENCE,
  UTILS,
  PARCEL,
  ADMIN,
};
